// extracted by mini-css-extract-plugin
export default {"container":"HomeDetailsData_container__B+iV7","info":"HomeDetailsData_info__bW0Yx"};